<div style="width: 100% !important">
  <div *ngIf="!sugestionImportant && !noData" class="search-status-container" role="status" aria-live="polite" aria-busy="true">
    <div class="search-animation">
      <div class="search-spinner"></div>
    </div>
    <p class="search-message">
      Estamos buscando sugerencias para
      <strong>{{ actualItinerary?.destination[0]?.destination_info?.cityName || "tu destino" }}</strong>
    </p>
    <p class="search-tip text-muted">Esto puede tomar unos segundos. Mientras tanto, puedes seguir explorando.</p>
  </div>

  <div *ngIf="noData" class="no-results-container" role="alert" aria-live="polite">
    <h3 class="no-results-title">No se encontraron sugerencias</h3>
    <p class="no-results-message">
      No hemos encontrado sugerencias disponibles para
      <strong>{{ actualItinerary?.destination[0]?.destination_info?.cityName || "tu destino" }}</strong
      >.
    </p>
    <p class="no-results-tip text-muted">Intenta modificar tus criterios de búsqueda o consulta nuevamente más tarde.</p>
  </div>

  <div *ngIf="sugestionImportant" class="w-100 mb-3" id="visited-component">
    <div class="w-100">
      <div class="p-3" style="background-color: #ffffff; border-radius: 12px">
        <!-- suggestion title -->
        <h3 class="mb-3" style="font-size: 20px; font-weight: 600; font-family: &quot;Muli&quot;, sans-serif">Imperdible</h3>

        <!-- suggestion img -->
        <div class="mb-3" style="height: 250px">
          <img
            *ngIf="sugestionImportant?.image !== null"
            src="{{ sugestionImportant.image }}"
            style="width: 100%; height: 100%; object-fit: cover"
            alt=""
          />
        </div>

        <!-- Price And Action -->
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex flex-column">
            <span
              style="font-size: 12px; font-weight: 400; text-transform: normal; line-height: 1; font-family: &quot;Muli&quot;, sans-serif"
              >Desde</span
            >
            <h3
              [ngStyle]="{ 'font-size': sugestionImportant?.price | dynamicFontSize: 18 : fontSizeAdjustments }"
              style="font-weight: 600; text-transform: normal; line-height: 1; font-family: &quot;Muli&quot;, sans-serif"
            >
              {{ currencyAgency?.code }} {{ sugestionImportant?.price | number: "1.2-2" }}
            </h3>
          </div>

          <button
            (click)="openModal(modalTours, 'tour', 'imperdible', null)"
            class="btn btn-select"
            [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          >
            Seleccionar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="sugestionEssencial && sugestionEssencial.length > 0" style="background-color: #ffffff; border-radius: 12px" class="p-3">
    <h3 class="mb-2" style="font-size: 20px; font-weight: 600; font-family: &quot;Muli&quot;, sans-serif">Escencial</h3>

    <div class="d-flex flex-column">
      <ng-container *ngFor="let essencial of sugestionEssencial; let index = index">
        <div
          class="w-100 p-3 mb-2 essencial-card"
          [ngStyle]="{ 'background-image': essencial?.image ? 'url(\'' + essencial.image + '\')' : null }"
          role="img"
          [attr.aria-label]="essencial?.title || 'imagen'"
        >
          <div
            style="
              position: absolute;
              left: 0;
              top: 0;
              background: linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
              width: 100%;
              height: 100%;
              z-index: 10;
            "
          ></div>

          <div class="row h-100" style="position: relative; z-index: 20">
            <div class="col-7 h-100">
              <div class="h-100 d-flex flex-column align-items-start justify-content-between">
                <span class="essencial-tag">Popular</span>

                <div>
                  <h4 class="essencial-title">
                    {{ essencial?.title }}
                  </h4>
                  <p class="essencial-description m-0">{{ essencial?.description }}</p>
                </div>
              </div>
            </div>

            <div class="col-5 pl-0 h-100">
              <div class="h-100 d-flex flex-column align-items-end justify-content-between">
                <div
                  class="essencial-tag"
                  style="width: 100%; padding: 5px 0px; padding-left: 15px; border-radius: 10px; border: 3px solid"
                  [ngStyle]="{ 'border-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                >
                  <span style="font-size: 10px; font-weight: 400">Desde</span>

                  <p
                    class="d-flex flex-column align-items-start m-0"
                    [ngStyle]="{ 'font-size': essencial?.price | dynamicFontSize: 14 : fontSizeAdjustments }"
                    style="font-weight: 700; font-family: &quot;Muli&quot;, sans-serif"
                  >
                    <span style="line-height: 1">{{ currencyAgency?.code }}</span>
                    <span style="line-height: 1.1">
                      {{ essencial?.price | number: "1.2-2" }}
                    </span>
                  </p>
                </div>

                <button
                  class="btn btn-select w-100"
                  [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                  style="font-size: 11px; padding: 5px 20px"
                  (click)="openModal(modalTours, 'tour', 'essencial', index)"
                >
                  Seleccionar
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
